export default __webpack_public_path__ + "static/media/canvas-background-light.aec70403.svg";